import React from 'react'

import { ProgressBar } from '../../../components/ProgressBar/ProgressBar'

import './Soldout.scss'

export const Soldout = () => {
  return (
    <div className="soldout">
      <h1 className="title">
        모든 쿨캣츠 품절
      </h1>
      <ProgressBar percent={ 100 } />
    </div>
  )
}